import { VolumesTabView } from '@valiant/ui-shared'
import type { MonthlyVolumeData } from '@valiant/ui-shared'
import { useGetMonthlyVolumesQuery } from '@/generated/graphql'

interface VolumesTabProps {
  groupId?: string
  companyId?: string
  searchTerm?: string
}

export function VolumesTab({ groupId, companyId, searchTerm }: VolumesTabProps = {}) {
  const [{ data: volumesData, fetching: volumesLoading }] = useGetMonthlyVolumesQuery({
    variables: {
      filter:
        groupId || companyId
          ? {
              ...(groupId && { groupId }),
              ...(companyId && { companyId }),
            }
          : undefined,
    },
  })

  const monthlyVolumes: MonthlyVolumeData[] = (volumesData?.getMonthlyVolumes || []).map(
    (volume) => ({
      month: volume.month,
      totalUsd: volume.totalUsd,
      totalUsdRaw: volume.totalUsdRaw,
      totalGroupFeeUsd: volume.totalGroupFeeUsd,
      totalGroupFeeUsdRaw: volume.totalGroupFeeUsdRaw,
      totalLpFeeUsd: volume.totalLpFeeUsd,
      totalLpFeeUsdRaw: volume.totalLpFeeUsdRaw,
      lpFees: volume.lpFees.map((lpFee) => ({
        lpId: lpFee.lpId,
        lpName: lpFee.lpName,
        totalUsd: lpFee.totalUsd,
        totalUsdRaw: lpFee.totalUsdRaw,
        groupFeeUsd: lpFee.groupFeeUsd,
      })),
      mints: volume.mints.map((mint) => ({
        mint: mint.mint,
        symbol: mint.symbol,
        volume: mint.volume,
        groupFee: mint.groupFee,
        lpFee: mint.lpFee,
        lpFees: mint.lpFees.map((lpFee) => ({
          lpId: lpFee.lpId,
          lpName: lpFee.lpName,
          fee: lpFee.fee,
        })),
      })),
    }),
  )

  return (
    <VolumesTabView
      searchTerm={searchTerm}
      monthlyVolumes={monthlyVolumes}
      loading={volumesLoading}
      showExportButton={true}
      showGroupFeesPerLp
      variant="admin"
    />
  )
}
